/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import { useNavigate, Link } from 'react-router-dom';
import Navbar from '../../Navbar';
import Header from '../../Header';
import Loader from '../../Loader';
import baseUrl from '../../BaseUrl';
import { saveAs } from 'file-saver';
 
const CallPassDashboard = () => {
    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [cid, setCid] = useState('');
    const [expire, setExpire] = useState('');
    // const [users, setUsers] = useState([]);
    // const [error, setError] = useState(null);
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [callPassBrandedCallingAccess, setCallPassBrandedCallingAccess] = useState(false);
    const [userCallPassBrandedCallingAccess, setUserCallPassBrandedCallingAccess] = useState(false);
    const [callPassIdentitiesAccess, setCallPassIdentitiesAccess] = useState(false);
    const [userCallPassIdentitiesAccess, setUserCallPassIdentitiesAccess] = useState(false);
    const [userCallPassExportAccess, setUserCallPassExportAccess] = useState(false);
    const [showAgreementModal, setShowAgreementModal] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);
 
    const navigate = useNavigate();
 
    useEffect(() => {
        refreshToken();
        getUserAccess();     
        // getUsers();
    }, []);

    useEffect(() => {
        if(cid){
            getCustomerAccess();
        }
    }, [cid]);
 
    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
        } catch (error) {
           
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }

    
    const getUserAccess = async () => {
        try {
            setPopupOpen(true);
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            setPopupOpen(false);
            console.log(response.data.results);
            setAccess(response.data.results);
            const branded = parseInt(response.data.user_call_pass_branded_calling_switch) >= 1;
            const identities = parseInt(response.data.user_call_pass_display_identities_switch) >= 1;
            const exportAccess = parseInt(response.data.user_call_pass_export_switch) >= 1;
            setUserCallPassBrandedCallingAccess(branded);
            setUserCallPassIdentitiesAccess(identities);
            setUserCallPassExportAccess(exportAccess);
            if (!branded && !identities && !exportAccess) {
                navigate('/dashboard');
                return;
            }
            
        } catch (error) {
           console.log(error);
        //    setIsLoading(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    
    const hasPermission = (permission) => {
        return access.some((item) => item.access === permission);
      };

    const handleAgree = () => {
        setShowAgreementModal(false);
        navigate('/call-pass-display-identities');
    };

    const handleCancel = () => {
        setShowAgreementModal(false);
    };

 
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
 
    const getCustomerAccess = async () => {
        try {
            if(role <= 1){
                // Super admin: always full access (user-level also hardcoded 1 by backend)
                setCallPassBrandedCallingAccess(true);
                setCallPassIdentitiesAccess(true);
            } else if(role === 2){
                // BBD user: no company restriction; personal switch (from getUserAccess) gates boxes
                setCallPassBrandedCallingAccess(true);
                setCallPassIdentitiesAccess(true);
            } else {
                // Customer user: governed by company-level switch
                const response = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setCallPassBrandedCallingAccess(parseInt(response.data.call_pass_branded_calling_switch) >= 1);
                setCallPassIdentitiesAccess(parseInt(response.data.call_pass_display_identities_switch) >= 1);
            }
        } catch (error) {
           console.log(error);
        }
    };

    const handleExportDisplayIdentities = async (bapId) => {
        try {
            const params = bapId ? `?bap_id=${bapId}` : '';
            const response = await axiosJWT.get(`${baseUrl}/export-bbd-display-identities${params}`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob'
            });
            saveAs(response.data, 'display_identities.xlsx');
        } catch (error) {
            console.log(error);
        }
    };

    const handleExportTNs = async (activeOnly, bapId) => {
        try {
            const params = new URLSearchParams({ active: activeOnly });
            if (bapId) params.set('bap_id', bapId);
            const response = await axiosJWT.get(`${baseUrl}/export-bbd-tns?${params.toString()}`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob'
            });
            const filename = activeOnly ? 'tns_active.xlsx' : 'tns_all.xlsx';
            saveAs(response.data, filename);
        } catch (error) {
            console.log(error);
        }
    };

    const handleShowAgreement = (e) => {
        e.preventDefault(); 
        if(role > 2) {
            setShowAgreementModal(true);
        }else {
            navigate('/call-pass-display-identities');
        }
    }
 
    return (
        <div className="panelbox">
           <Navbar  token={token} access = {access}/>
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page">
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title">
                                <h1>Call Pass - Branded Calling</h1>
                            </div>
                        </div>
                        <div className="col-6">

                        </div>
                    </div>
                    <div className="row numberboxes">
                        {(callPassBrandedCallingAccess && userCallPassBrandedCallingAccess) && <div className='col-md-3'>
                            <Link to='/call-pass-summary'>
                                <div className="dashboard-box" id="number">
                                    <div className="imagebox">
                                        <img src="images/bxs-phone.png" />
                                    </div>
                                    <h3>Call Pass Summary</h3>
                                </div>
                            </Link>
                        </div>}

                        {(callPassIdentitiesAccess && userCallPassIdentitiesAccess) && <div className='col-md-3'>
                            <a href="#" onClick={handleShowAgreement}>
                                <div className="dashboard-box" id="inventory">
                                    <div className="imagebox">
                                        <img src="images/bxs-phone.png" />
                                    </div>
                                    <h3>Call Pass Display Identities</h3>
                                </div>
                            </a>
                        </div>}

                        {userCallPassExportAccess && <div className='col-md-3'>
                            <a href="#" onClick={(e) => { e.preventDefault(); setShowExportModal(true); }}>
                                <div className="dashboard-box" id="export-call-pass">
                                    <div className="imagebox">
                                        <img src="images/bxs-phone.png" />
                                    </div>
                                    <h3>Export Call Pass</h3>
                                </div>
                            </a>
                        </div>}

                    </div>
                </div>
            </div>
            {showAgreementModal && <AgreementModal onAgree={handleAgree} onClose={handleCancel} />}
            {showExportModal && (
                <ExportCallPassModal
                    onClose={() => setShowExportModal(false)}
                    onExportDisplayIdentities={handleExportDisplayIdentities}
                    onExportTNs={handleExportTNs}
                    axiosJWT={axiosJWT}
                    token={token}
                />
            )}
        </div>
    )
}

const AgreementModal = ({ onClose, onAgree }) => {
    return (
        <div className="fixed inset-0 bg-overlay flex items-center justify-center">
            <div className="bg-white rounded-md w-600 text-left">
                <div className="p-6">
                    <h3 className="text-center mb-4 text-xl">Agreement</h3>
                    <p>By continuing, you agree to the following:</p>
                    <ol className="list-decimal pl-5 leading-relaxed">
                        <li>Any changes made in this system typically take up to 30 minutes to propagate through the system and to be reflected in calls.</li>
                        <li>Use of this system is subject to the Call Pass Terms of Use Agreement, Telephone Number Authorization form, and associated agreements.</li>
                        <li>You attest and warrant that each telephone number and Display Identity will only be used when making calls consistent with the associated Display Identity.</li>
                        <li>It is your responsibility to test all numbers to confirm that they are working as expected. Unless you notify us otherwise by emailing callpass@broadbanddynamics.com, use of the numbers, or passage of 24 hours from requested changes, will be considered your acknowledgement and confirmation that all numbers and any associated changes are working as expected.</li>
                    </ol>
                </div>
                <div className="text-center mt-5 pb-5">
                    <button className="btn-primary mr-3" onClick={onAgree}>I Agree</button>
                    <button className="btn-secondary" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};
 
const ExportCallPassModal = ({ onClose, onExportDisplayIdentities, onExportTNs, axiosJWT, token }) => {
    const [tnExportType, setTnExportType] = useState('all');
    const [selectedBapId, setSelectedBapId] = useState('');
    const [customers, setCustomers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        axiosJWT.get(`${baseUrl}/active-user-company`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            const list = (res.data || []).filter(c => c.id !== 1);
            setCustomers(list.map(c => ({ bap_id: c.id, customer_name: c.cname })));
        }).catch(err => console.log(err));
    }, []);

    const handleExport = async (exportFn) => {
        setIsLoading(true);
        await exportFn();
        setIsLoading(false);
        onClose();
    };

    const bapId = selectedBapId || null;

    return (
        <div className="fixed inset-0 bg-overlay flex items-center justify-center">
            <div className="bg-white rounded-md w-600 text-left">
                <div className="p-6">
                    <h3 className="text-center mb-4 text-xl">Export Call Pass</h3>

                    {isLoading && <Loader />}

                    <div className="mb-4">
                        <h4 className="mb-2">Customer</h4>
                        <select
                            className="form-control"
                            value={selectedBapId}
                            onChange={e => setSelectedBapId(e.target.value)}
                            disabled={isLoading}
                        >
                            <option value="">-- All Customers --</option>
                            {customers.map(c => (
                                <option key={c.bap_id} value={c.bap_id}>{c.customer_name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-4">
                        <h4 className="mb-2">Option 1: Display Identities</h4>
                        <button
                            className="btn-primary"
                            disabled={isLoading}
                            onClick={() => handleExport(() => onExportDisplayIdentities(bapId))}
                        >
                            Export Active Display Identities
                        </button>
                    </div>

                    <div className="mb-4">
                        <h4 className="mb-2">Option 2: TN</h4>
                        <div className="mb-2">
                            <label className="mr-3">
                                <input
                                    type="radio"
                                    name="tnExportType"
                                    value="all"
                                    checked={tnExportType === 'all'}
                                    onChange={() => setTnExportType('all')}
                                    disabled={isLoading}
                                    className="mr-1"
                                />
                                All
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="tnExportType"
                                    value="active"
                                    checked={tnExportType === 'active'}
                                    onChange={() => setTnExportType('active')}
                                    disabled={isLoading}
                                    className="mr-1"
                                />
                                Active Only
                            </label>
                        </div>
                        <button
                            className="btn-primary"
                            disabled={isLoading}
                            onClick={() => handleExport(() => onExportTNs(tnExportType === 'active', bapId))}
                        >
                            Export TN
                        </button>
                    </div>
                </div>
                <div className="text-center mt-2 pb-5">
                    <button className="btn-secondary" disabled={isLoading} onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default CallPassDashboard